import { Injectable } from '@angular/core'
@Injectable()

export class APIService {
    apiURL: string = "";
    constructor() {
    }

}


// WEBPACK FOOTER //
// ./src/app/services/api.service.ts